import * as yup from "yup";
import { emailRegEx } from "./RegEx";

export const fleetInquirySchema = yup.object().shape({
  // First step
  firstName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  lastName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  fleetUsageCompanyName: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Email is required"),
  email: yup
    .string()
    .matches(emailRegEx, "Should be valid email")
    .required("Email is required"),
  address: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("Adress is required"),
  city: yup
    .string()
    .min(3, "Must be at least 3 char")
    .max(50, "Must be at most 50 char")
    .required("City is required"),
  zipCode: yup
    .string()
    .trim()
    .min(3, 'Zip code must be at least 3 characters long.')
    .max(10, 'Zip code must be no more than 10 characters long.')
    .required("ZIP code is required"),
  idCountry: yup.number().required("Country is required"),
  idState: yup.number(),
  phoneNumber: yup
    .string()
    .required("Phone is required'")
    .trim()
    .min(12, "Must be at least 12 char")
    .max(17, "Must be at most 17 char"),

  // Second step
  businessType: yup.string().required("Industry is required"),
  numberOfVehicles: yup.number().required("Vehicles number is required'"),

  // Third step
  timeTable: yup
    .number()
    .oneOf([3, 6, 12], "Duration must be either 3, 6, or 12")
    .required("Duration is required"),
  customFeatures: yup.string().max(500, "Must be at most 500 char"),

  // Fourth step
  hoursFrom: yup.string().required("Time is required"),
  hoursTo: yup.string().required("Time is required"),
  preferredMode: yup
    .number()
    .oneOf([0, 1], "Should be email or phone")
    .required("Method is required"),
});
